import { createContext } from 'react';
export const AllTripsContext = createContext();